const t = {
  name: "BankOut",
  dimensions: { width: 24, height: 24 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M9.7,0h4.6L21,4.4V7h-2v6h2v2H3v-2h2V7H3V4.4L9.7,0z M15,7v6h2V7H15z M11,7v6h2V7H11z M7,7v6h2V7H7z M10.3,2
			L5.8,5h12.4l-4.5-3H10.3z"/>
		<path class="st0" d="M13,17v3.2l2-2l1.4,1.4L12,24l-4.4-4.4L9,18.2l2,2V17H13z"/>
	</g>
</g>
</svg>
  `
};
export {
  t as BankOut
};
